/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FareType,
    FareTypeFromJSON,
    FareTypeFromJSONTyped,
    FareTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface FareTypeFilterItemOutput
 */
export interface FareTypeFilterItemOutput {
    /**
     * 
     * @type {string}
     * @memberof FareTypeFilterItemOutput
     */
    displayText?: string | null;
    /**
     * 
     * @type {FareType}
     * @memberof FareTypeFilterItemOutput
     */
    value?: FareType;
    /**
     * 
     * @type {boolean}
     * @memberof FareTypeFilterItemOutput
     */
    isEffective?: boolean;
}

export function FareTypeFilterItemOutputFromJSON(json: any): FareTypeFilterItemOutput {
    return FareTypeFilterItemOutputFromJSONTyped(json, false);
}

export function FareTypeFilterItemOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): FareTypeFilterItemOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'displayText': !exists(json, 'displayText') ? undefined : json['displayText'],
        'value': !exists(json, 'value') ? undefined : FareTypeFromJSON(json['value']),
        'isEffective': !exists(json, 'isEffective') ? undefined : json['isEffective'],
    };
}

export function FareTypeFilterItemOutputToJSON(value?: FareTypeFilterItemOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'displayText': value.displayText,
        'value': FareTypeToJSON(value.value),
        'isEffective': value.isEffective,
    };
}


